// link to documentation: https://www.highcharts.com/demo/highcharts/line-chart

import formatDateLabel from "../methods/utils/formatDateLabel";
import formatYAxisLabel from "../methods/utils/formatYAxisLabel"

export default function (props) {
    // if label categories is date types we want to format them
    props.categories = props.categories.map((category) => formatDateLabel(category)) 

    return {
        chart: {
            type: "line",
        },
        title: {
            text: props.title,
            align: 'left',

        },
        subtitle: {
            text: props.subtitle,
            align: 'left',
        },
        yAxis: {
            title: {
                text: props.yaxisTitle
            },
            labels: {
                formatter: function () {
                    return `${formatYAxisLabel(this.value, props.yAxisDecimals)}${props.yaxisLabelFormat}`;
                }
            },
            accessibility: {
                description: props.accaccessibilityDescriptionYaxis
            }
        },
        xAxis: {
            title: {
                text: props.xaxisTitle
            },
            accessibility: {
                description: props.accaccessibilityDescriptionXaxis,
                rangeDescription: props.accaccessibilityRangeDescriptionXaxis
            },
            // handle this within a logic function
            categories: props.categories,
            tickPositioner: props.tickPositioner, // a function
            labels: {
                formatter: function () {
                    return this.value;
                }
            }
        },
        tooltip: {
            shared: true,
            crosshairs: true,
            valueSuffix: props.tooltipValueSuffix,
            valueDecimals: props.yAxisDecimals,
            useHTML: true,
            headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
                pointFormat: '<tr><td><span style="color:{color}">\u25CF</span> {series.name}: ' +
                    '</td>' +
                    '<td style="text-align: right"><b>{point.y} {props.tooltipValueSuffix}</b></td></tr>',
                footerFormat: '</table>',
        },
        colors: props.colors,
        series: props.seriesData,
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
            }]
        }
    }
}
